import { parseCssGradient } from 'utils/gradients'

export const isTransparent = (color) => color === 'transparent'
export const isHexColor = (color) => !!color.match(/^#[0-9A-Fa-f]{6}$/)
export const isGradient = (color) => !!parseCssGradient(color).stops.length

export const styleForColorOrGradient = (color) => {
  if (isTransparent(color)) {
    return {}
  }

  return isGradient(color)
    ? { backgroundImage: `linear-gradient(${color})` }
    : { backgroundColor: color }
}
